export const TEST_KEY = 'test';
export const AUTH_KEY = 'auth';